<template>
    <div class="service-package-card" :class="{ recommended: servicePackage.isRecommended }">
        <ServicePackage
            :addon="servicePackage"
            :usps="servicePackage.usps"
            :isSelected="isSelected"
            @update:modelValue="handleSelection(addon)" />
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType, computed } from 'vue';
    import { t } from '@shared/helpers/translation';
    import { UpSellAddonServicePackage } from '@/api/MyBookingSession/myBookingSession.interfaces';
    import { getServicePackageContent } from '@/components/modals/Variants/ServicePackage/ServicePackage.helpers';
    import ServicePackage from '@ui/components/ServicePackage/ServicePackage.vue';

    export default defineComponent({
        name: 'ServicePackageCard',
        methods: { t },
        components: { ServicePackage },
        props: {
            addon: {
                type: Object as PropType<UpSellAddonServicePackage>,
                required: true,
            },
            selectedAddon: {
                type: Object as PropType<UpSellAddonServicePackage | undefined>,
                required: true,
            },
            onSelect: {
                required: true,
                type: Function as PropType<(addon: UpSellAddonServicePackage) => void>,
            },
        },
        setup(props) {
            const servicePackage = computed(() => getServicePackageContent(props.addon));
            const isSelected = computed(() => props?.selectedAddon?.Id === props.addon.Id);

            const handleSelection = (addon: UpSellAddonServicePackage) => {
                props.onSelect && props.onSelect(addon);
            };

            return {
                servicePackage,
                isSelected,
                handleSelection,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'ServicePackageCard';
</style>
